import { createSlice } from "@reduxjs/toolkit";
import {
  extractContactList,
  toGetContactCities,
  toGetContactCountries,
  toGetContactTags,
} from "../actions/contactUs.actions";

const initialState = {
  countries: {
    list: [] as any[],
    status: "idle",
  },
  cities: {
    list: [] as any[],
    status: "idle",
  },
  tags: {
    list: [] as any[],
    status: "idle",
  },
  error: null as unknown | null,
};

export const contactUsSlice = createSlice({
  name: "contactUsPage",
  initialState,
  reducers: {
    clearContactCities: (state) => {
      state.cities = { list: [], status: "idle" };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toGetContactCountries.pending, (state) => {
      state.countries = { list: [], status: "loading" };
    });
    builder.addCase(toGetContactCountries.fulfilled, (state, action) => {
      state.countries = {
        list: extractContactList(action.payload),
        status: "succeeded",
      };
    });
    builder.addCase(toGetContactCountries.rejected, (state, action) => {
      state.countries = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetContactCities.pending, (state) => {
      state.cities = { list: [], status: "loading" };
    });
    builder.addCase(toGetContactCities.fulfilled, (state, action) => {
      state.cities = {
        list: extractContactList(action.payload),
        status: "succeeded",
      };
    });
    builder.addCase(toGetContactCities.rejected, (state, action) => {
      state.cities = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetContactTags.pending, (state) => {
      state.tags = { list: [], status: "loading" };
    });
    builder.addCase(toGetContactTags.fulfilled, (state, action) => {
      state.tags = {
        list: extractContactList(action.payload),
        status: "succeeded",
      };
    });
    builder.addCase(toGetContactTags.rejected, (state, action) => {
      state.tags = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export const { clearContactCities } = contactUsSlice.actions;
export default contactUsSlice.reducer;
